import { MappingItem } from '../../GTM'
import { getMapProductDetails } from '../functions/getMapProductDetails'

export const searchData = (
    productDetails = getMapProductDetails()
): MappingItem => {
    return {
        searchTerm: ['searchTerm'],
        currencyCode: [
            [
                'products',
                'items',
                '0',
                'price_range',
                'minimum_price',
                'final_price',
                'currency'
            ],
            [
                'items',
                '0',
                'price_range',
                'minimum_price',
                'final_price',
                'currency'
            ]
        ],
        totalCount: ['totalCount'],
        productsDetails: productDetails
    }
}
